<template>
  <div>
    <div class="notice" v-if="userRankList.length">
      <van-notice-bar :scrollable="false" background="transparent">
        <van-swipe vertical class="notice-swipe" :show-indicators="false" :touchable="false" :autoplay="3000">
          <van-swipe-item v-for="item in userRankList">
            <div class="cell">
              <img class="avatar" :src="item.headImg" />
              <span class="nickname van-ellipsis">{{ item.nickname }}</span>
              <span>&nbsp;{{ item.tip }}</span>
            </div>
          </van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="head">
      <img class="bg" :src="getImgUrl('publicMobile/promotion-activity/bg_head.jpg?v=1')" />
      <img class="avatar" v-if="data.mine" :src="data.mine.headImg" />
      <img class="btn" @click="go" :src="getImgUrl('publicMobile/promotion-activity/btn.png')" />
      <img class="rule" @click="rule" :src="getImgUrl('publicMobile/promotion-activity/rule.png')" />
      <div class="head_content" v-if="data.mine">
        <h1 v-if="data.mine.rank != 0 && data.mine.rank < 101">当前排名 第{{ data.mine.rank }}名</h1>
        <h1 v-if="data.mine.rank > 100">快去推广！</h1>
        <template v-if="data.mine.rank != 1">
          <h4>超越上一名仅需推广</h4>
          <h4>{{ data.mine.diffNums }}家门店</h4>
        </template>
        <template v-if="data.mine.rank == 1">
          <h4>推广更多门店</h4>
          <h4>保持领先优势！</h4>
        </template>
      </div>
    </div>
    <div class="content" :style="`background-image: url(${getImgUrl('publicMobile/promotion-activity/bg-y.jpg')})`">
      <div class="box" v-for="item in data.list" :key="item.memberId">
        <div class="box1">
          <div class="avatar_wrap">
            <img class="avatar" :src="item.headImg || 'https://pro-yeahgo-oss.yeahgo.com/icon/avatar_death.png'">
            <img :class="`avatar_ avatar_${item.rank}`"
              :src="`${getImgUrl(`publicMobile/promotion-activity/${item.rank}.png`)}`">
          </div>
          <div class="info">
            <div class="nickname van-ellipsis">{{ item.nickname }}</div>
            <div>{{ item.phone }}</div>
          </div>
        </div>
        <div class="box2">{{ item.inviteNums }}</div>
        <div class="box3">{{ item.prizeDesc }}</div>
      </div>
    </div>
    <img class="footer" :src="getImgUrl('publicMobile/promotion-activity/footer.jpg')" />
    <van-popup v-model="show" style="width:90%;background: transparent;" closeable>
      <div class="rule_wrap">
        <img :src="getImgUrl('publicMobile/promotion-activity/rule_title.jpg')" />
        <p>一、活动期:2024年3月25日10:00至3月31日24:00</p>
        <p>二、奖励条件及内容:</p>
        <p>1、在7天活动期内，每推广一个合作门店签约，赠送价值 1000元人民币的IPO股权。</p>
        <p>2、在7天活动期内完成2个有效的合作门店(即签约并付服务费的门店达2个)可参加评选，获得名次的奖励如下:</p>
        <p style="text-indent: 2em;">一等奖:1名，赠送价值4万元人民币的IPO股权+华为P60手机1台。</p>
        <p style="text-indent: 2em;">二等奖:30名，赠送价值2万元人民币的IPO股权+罗西尼手表(市场价4980元)1只。</p>
        <p style="text-indent: 2em;">三等奖:50名，赠送价值1万元人民币的IPO股权+罗西尼手表(市场价4980元)1只。</p>
        <p>说明:</p>
        <p>1、按照完成业绩的时间先后顺序评选名次，业绩名次不重复。</p>
        <p>2、获奖名单以公司官方公布为准。</p>
        <p>3、奖品领取方式:在颁奖盛典中现场颁发 (具体时间以公司公布为准 )。</p>
        <p>约购平台保留法律许可范围内解释本活动的权利。</p>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { post } from '@/utils/request'
import { getImgUrl } from '@/utils/tools'
import { Popup, NoticeBar, Swipe, SwipeItem } from 'vant'

export default {
  components: {
    [Popup.name]: Popup,
    [NoticeBar.name]: NoticeBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      data: {},
      token: '',
      show: false,
      userRankList: []
    }
  },
  computed: {

  },
  created() {
    this.$bridge.callHandler('getUserInfo', {}, (res) => {
      const d = JSON.parse(res)
      this.token = d.data.accessToken
      this.getData()
    })
    // this.getData()
  },
  methods: {
    getImgUrl,
    getData() {
      post({
        url: '/healthy/auth/providerRank/userRank',
        options: {
          token: this.token
        }
      }).then(res => {
        if (res.code === 0) {
          this.data = res.data
          this.userRankList = res.data.scrollList
        }
      })
      
    },
    go() {
      const data = {
        code: 0,
        msg: 'success',
        data: {
          url: this.data.jumpUrl,
        }
      }
      const zero = JSON.stringify(data)
      this.$bridge.callHandler(
        'router',
        zero,
      )
    },
    rule() {
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.notice {
  position: fixed;
  left: 0;
  top: 540px;
  width: 100%;
  z-index: 100;

  ::v-deep .van-notice-bar {
    height: 50px !important;
  }

  .cell {
    background: rgba(0,0,0,0.3);
    padding: 5px;
    border-radius: 30px;
    overflow: hidden;
    height: 40px;
    display: inline-flex;
    align-items: center;
    color: #fff;
  }

  .avatar {
    width: 30px;
    height: 30px;
    border-radius: 100%;
    margin-right: 5px;
  }

  .nickname {
    width: 70px;
  }
}

.notice-swipe {
  height: 50px;
  line-height: 50px;
}

.head {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .bg {
    width: 100%;
  }

  .avatar {
    width: 65px;
    height: 65px;
    border-radius: 100%;
    overflow: hidden;
    position: absolute;
    top: 260px;
  }

  .btn {
    width: 130px;
    position: absolute;
    bottom: 150px;
  }

  .rule {
    width: 50px;
    right: 0;
    top: 220px;
    position: absolute;
  }

  .head_content {
    position: absolute;
    width: 100%;
    top: 360px;
    text-align: center;
    color: #fff;
  }

  h1 {
    margin-bottom: 1cqh;
    font-size: 20px;
  }
}

.content {
  background-repeat: repeat-y;
  background-size: 100%;
  min-height: 200px;
  padding: 5px 27px 10px 30px;
}

.box {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  align-items: center;
  font-size: 12px;

  .box1 {
    width: 123px;
    display: flex;

    .avatar_wrap {
      position: relative;
    }

    .avatar {
      width: 45px;
      height: 45px;
      border-radius: 100%;
    }

    .avatar_ {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 48px;
      transform: translate(-2px, 2px);
    }

    .avatar_1,
    .avatar_2,
    .avatar_3 {
      width: 55px;
      transform: translate(-1px, 1px);
    }

    .info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 10px;
    }

    .nickname {
      width: 70px;
    }
  }

  .box2 {
    width: 57px;
    text-align: center;
  }

  .box3 {
    width: 131px;
  }
}

.footer {
  width: 100%;
}

.rule_wrap {
  width: 100%;
  border-radius: 10px;
  border: 1px solid red;
  overflow: hidden;
  background: #fff;
  padding: 10px;

  img {
    width: 100%;
  }
}
</style>